// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
/**
 * Action to report valid bucket IDs for a plan
 */ export class ReportValidBucketsAction extends TypedAction(ActionType.ReportValidBucketsAction) {
    loggingData() {
        return {
            planId: this.planId,
            bucketCount: this.validBuckets.length.toString()
        };
    }
    constructor(planId, validBuckets){
        super(), this.planId = planId, this.validBuckets = validBuckets;
    }
}
/**
 * Action to report valid custom field definition IDs for a plan
 */ export class ReportValidCustomFieldDefinitionsAction extends TypedAction(ActionType.ReportValidCustomFieldDefinitionsAction) {
    loggingData() {
        return {
            planId: this.planId
        };
    }
    constructor(planId, validCustomFieldDefinitions){
        super(), this.planId = planId, this.validCustomFieldDefinitions = validCustomFieldDefinitions;
    }
}
/**
 * Action to report valid goal IDs for a plan
 */ export class ReportValidGoalsAction extends TypedAction(ActionType.ReportValidGoalsAction) {
    loggingData() {
        return {
            planId: this.planId,
            goalCount: this.validGoals.length.toString()
        };
    }
    constructor(planId, validGoals){
        super(), this.planId = planId, this.validGoals = validGoals;
    }
}
